import { Link } from 'react-router-dom';
import { maskDecimal } from '@givebutter/util';
import { faGift } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PledgeActions } from './PledgeActions';
import { PledgeContent } from './PledgeContent';
import * as ActivityItem from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/ActivityItem';
import { CurrencySymbol } from 'customHooks/useCurrencySymbol';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { Contact, PledgeCreatedActivity } from 'types/domain';

interface PledgeCreatedProps {
    item: PledgeCreatedActivity;
    contact: Contact | null;
}

const PledgeCreated = ({ item, contact }: PledgeCreatedProps) => {
    const { accountId } = useCurrentAccount();

    return (
        <ActivityItem.Root>
            <ActivityItem.Trigger>
                <ActivityItem.Icon className="bg-violet-50">
                    <FontAwesomeIcon className="text-violet-500" icon={faGift} />
                </ActivityItem.Icon>
                <p className="text-left">
                    <span className="font-medium">
                        {contact?.first_name} {contact?.last_name}
                    </span>{' '}
                    <Link to={`/accounts/${accountId}/pledges/${item.resource.pledge.id}/edit`}>
                        pledged <CurrencySymbol />
                        {maskDecimal(item.resource.pledge.amount)}
                    </Link>{' '}
                    to{' '}
                    <Link
                        to={`/accounts/${accountId}/campaigns/${item.resource.pledge.campaign.id}`}
                    >
                        {item.resource.pledge.campaign.title}
                    </Link>
                </p>
                <PledgeActions pledge={item.resource.pledge} contact={contact} />
            </ActivityItem.Trigger>
            <ActivityItem.Content>
                <PledgeContent item={item.resource} />
            </ActivityItem.Content>
        </ActivityItem.Root>
    );
};

export { PledgeCreated };
